import React from 'react'
import { Steps, Button, Tooltip, Spin, Row, Typography, Switch, Col, Card, Modal, Form, Input, Radio, Checkbox, Select, Icon, Divider } from 'antd';

export default function NewEagleGreetingsModal(props) {

    const {doesShowNewMemberGreetingsProps, closeNewMemberGreetingsModalHandler} = props;
    
  return <Modal
        className='greetings-model'
        title={false}
        footer={false}
        visible={props.doesShowNewMemberGreetingsProps}
        centered
        onCancel={() => closeNewMemberGreetingsModalHandler()}
    >
            <div className="center">
                {/* <div>
                    <img src={warningAlert} width="40px" height="40px" />
                </div> */}
                <div className="greetings-title">Welcome to the National Eagle Scout Association!</div>
                <div className='greetings-Content'>
                    <p>
                        Congratulations on achieving the prestigious rank of Eagle Scout!<br/>
                        We are grateful for your commitment to upholding the mission, values,<br/>
                        and time-honored traditions of Scouting in your community and beyond.<br/>
                        As a token of appreciation, the NESA leadership is pleased to offer you a special<br/>
                        discount on your first membership purchase.
                    </p>
                    <span class="welcome-para-lastline">We look forward to welcoming you to NESA and supporting you on your continued Scouting journey!</span>
                </div>

                <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                        <div className='step-container margin-top-20' >
                            <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                closeNewMemberGreetingsModalHandler();
                            }} htmlType='submit'>NEXT </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
}



// WEBPACK FOOTER //
// ./src/components/Membership/NewEagleGreetingsModal.js